// extracted by mini-css-extract-plugin
module.exports = {"loop":"TradeLoops_loop_1Pxj7","loopBack":"TradeLoops_loopBack_2a_zU"};